export { default } from './Overlay'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Overlay/index.js